export default "__VITE_ASSET__tAv1cfNO__"